import { Button, Typography, theme } from 'antd'
import { env, useTranslate } from 'old/utils'
import { HorizontalLine, HorizontalContainer, VerticalContainer } from 'old/components/styled'
import { GoogleOutlined, AppleOutlined, FacebookOutlined, TwitterOutlined } from '@ant-design/icons'
import { LoginStrategy }  from 'old/types'
const  { Text } = Typography

type Props = {
    availableList: string[]
    hideOr: boolean
}

export const LoginSocialButtons = ({ availableList, hideOr }: Props) => {

    //translate:
    const { __ } = useTranslate()

    //theme:
    const { token: { fontSize, fontSizeSM, margin, colorTextDescription, marginXS, fontSizeLG, paddingXS, padding } } = theme.useToken()

    //layout:
    const isSingleColumnLayout = availableList.length !== 4 && availableList.length !== 6
    
    //render:
    return (
        <VerticalContainer style={{ gap: margin }}>

            {/* or */}
            {!hideOr &&
            <HorizontalContainer style={{ gap: marginXS }}>

                <HorizontalLine/>
                <Text style={{ fontSize: fontSizeSM, color: colorTextDescription, fontFamily: 'inter-medium' }}>{__`or_login_with`}</Text>
                <HorizontalLine/>

            </HorizontalContainer>}

            {(availableList.includes(LoginStrategy.GOOGLE) || availableList.includes(LoginStrategy.FACEBOOK)) &&
            <HorizontalContainer style={{ width: '100%', gap: margin, flexDirection: isSingleColumnLayout ? 'column' : 'row' }}>

                {/* google */}
                {availableList.includes(LoginStrategy.GOOGLE) &&
                <Button
                    size='large'
                    style={{
                        flex: 1,
                        width: '100%',
                        fontSize,
                        padding: `${paddingXS}px ${padding}px`
                    }}
                    icon={<GoogleOutlined style={{ fontSize: fontSizeLG }}/>}
                    onClick={() => location.href = env().GOOGLE_LOGIN_ENDPOINT}
                >
                    {__`google`}
                </Button>}

                {/* facebook */}
                {availableList.includes(LoginStrategy.FACEBOOK) &&
                <Button
                    size='large'
                    style={{
                        width: '100%',
                        flex: 1,
                        fontSize,
                        padding: `${paddingXS}px ${padding}px`
                    }}
                    icon={<FacebookOutlined style={{ fontSize: fontSizeLG }}/>}
                >
                    {__`facebook`}
                </Button>}

            </HorizontalContainer>}

            {(availableList.includes(LoginStrategy.APPLE) || availableList.includes(LoginStrategy.TWEETER)) &&
            <HorizontalContainer style={{ width: '100%', gap: margin, flexDirection: isSingleColumnLayout ? 'column' : 'row' }}>

                {/* apple */}
                {availableList.includes(LoginStrategy.APPLE) &&
                <Button
                    size='large'
                    style={{
                        flex: 1,
                        width: '100%',
                        fontSize,
                        padding: `${paddingXS}px ${padding}px`
                    }}
                    icon={<AppleOutlined style={{ fontSize: fontSizeLG }}/>}
                >
                    {__`apple`}
                </Button>}

                {/* twitter */}
                {availableList.includes(LoginStrategy.TWEETER) &&
                <Button
                    size='large'
                    style={{
                        flex: 1,
                        width: '100%',
                        fontSize,
                        padding: `${paddingXS}px ${padding}px`
                    }}
                    icon={<TwitterOutlined style={{ fontSize: fontSizeLG }}/>}
                >
                    {__`twitter`}
                </Button>}

            </HorizontalContainer>}

        </VerticalContainer>
    )

}
